import * as React from "react";
import { forwardRef } from "react";
const SvgCustomArrowRightAlt = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.3416 3.16666H0.333252V4.83333H10.3416V7.33333L13.6666 4L10.3416 0.666664V3.16666Z", fill: "#62676E" }));
const ForwardRef = forwardRef(SvgCustomArrowRightAlt);
export default ForwardRef;
